import clsx from 'clsx';
import { ComponentProps } from 'preact/compat';

import ZoolifeSVG from '@/components/ZoolifeLogo/svg';
import { cn } from '@/lib/utils';

interface UserProductImageProps extends Omit<ComponentProps<'div'>, 'children'> {
  imageURL?: string;
  title?: string;
  variant?: 'default' | 'giftup' | 'bundling';
}

const UserProductImage = ({ imageURL, title, className, variant = 'default', ...props }: UserProductImageProps) => {
  const isGiftup = variant === 'giftup';
  const isBundling = variant === 'bundling';

  return (
    <div
      className={cn(
        'preflight relative flex aspect-square items-center justify-center overflow-hidden rounded-lg border border-transparent',
        isGiftup ? 'bg-sun-400' : isBundling ? 'border-stone-200 bg-white' : 'bg-primary-green',
        className,
      )}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {imageURL ? (
        <img
          src={imageURL}
          alt={title || 'Product image'}
          className={clsx('preflight preflight-img size-full', isBundling ? 'object-contain' : 'object-cover')}
        />
      ) : (
        <ZoolifeSVG className={clsx('mx-1.5', isBundling || isGiftup ? 'text-forest-dark' : 'text-white')} />
      )}
    </div>
  );
};

export default UserProductImage;
